import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from 'src/environments/environment';
import { StorageService } from './storage.service';
import { TotemService } from './totem.service';

@Injectable({
  providedIn: 'root'
})
export class ValidateQrService {
  public encryptInfo;
  public decryptedInfo;

  tipoTransporte =  environment.tipoTransporte.pie;
  constructor(private localStorage: StorageService, private totemService: TotemService) { }


  validateQrCode(urlEncryptada: string){
    let palabra2 = '';
    if(urlEncryptada === null || urlEncryptada === undefined || urlEncryptada === ''){
      console.error('Sin clave - parametro vacio o nulo');
      return false;
    }

    try {
      console.log('Desencriptando:', urlEncryptada.substring(0, 30) + '...');
      palabra2 = this.decrypt(urlEncryptada);
      console.log('Desencriptado correctamente:', palabra2);

      const totemId = Number(palabra2);
      console.log('Validando totem ID:', totemId);

      if(!this.validarTotem(totemId)){
        console.warn('Totem no valido o no esta en la lista:', totemId);
        return false;
      } else{
        console.log('Totem valido, guardando inicio');
        this.setInicioTotem(palabra2);
        return true;
      }
    } catch (error) {
      console.error('Error en validateQrCode:', error);
      return false;
    }
  }

  async validarTotem(totId: number){
    let res = environment.listaTotems;
    return res.indexOf(totId) === -1 ? false : true;
  }

  setInicioTotem(totem : string){
    this.localStorage.setInicio(0 , 'Totem', Number(totem));
  }


  encrypt(info : string){
    console.log('[INFO]',info);
    //Encrypt Info
    const encript = encodeURIComponent(CryptoJS.AES.encrypt(JSON.stringify(info), 'MZZOSecreto').toString());
    console.log("encryptInfo",encript);
    return encript;
  }
    
  
  decrypt(info : string){
    try {
      if (!info || info === '') {
        throw new Error('Informacion vacia para desencriptar');
      }

      console.log('Desencriptando informacion...');
      // Decodificar URL-encoded characters (%2F -> /, %2B -> +, etc)
      const decodedInfo = decodeURIComponent(info);
      console.log('Informacion decodificada:', decodedInfo.substring(0, 30) + '...');

      // Desencriptar usando CryptoJS
      const deData = CryptoJS.AES.decrypt(decodedInfo, 'MZZOSecreto');
      const decryptedString = deData.toString(CryptoJS.enc.Utf8);

      if (!decryptedString) {
        throw new Error('La desencriptacion resulto en una cadena vacia');
      }

      console.log('Cadena desencriptada:', decryptedString);

      // Parsear JSON
      const decript = JSON.parse(decryptedString);
      console.log('JSON parseado:', decript);
      return decript;
    } catch (error) {
      console.error('Error en decrypt:', error);
      throw error;
    }
  }

   
}
